import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ChevronDownIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { DropdownMenu, renderDropdownItems } from '@air/primitive-dropdown-menu';

import {
  useDiscussionPanelContext,
  useDiscussionPanelContextSelector,
} from '~/components/AssetModal/shared/context/DiscussionsPanelContext/DiscussionsPanelContext';
import { ASSET_MODAL_DISCUSSION_VERSION_FILTERS } from '~/components/AssetModal/shared/context/DiscussionsPanelContext/discussionsPanelContextTypes';
import { discussionsVersionFilterSelector } from '~/components/AssetModal/shared/context/DiscussionsPanelContext/discussionsPanelContextUtils';
import { centralizedClipVersionNumberSelector } from '~/store/centralizedClip/selectors';

export const CommentsVersionsDropdown = () => {
  const versionNumber = useSelector(centralizedClipVersionNumberSelector);
  const { setDiscussionsVersionFilter } = useDiscussionPanelContext();
  const discussionsVersionFilter = useDiscussionPanelContextSelector(discussionsVersionFilterSelector);

  const options = useMemo(
    () => [
      {
        id: 'all-versions',
        label: 'All versions',
        onSelect: () => setDiscussionsVersionFilter(ASSET_MODAL_DISCUSSION_VERSION_FILTERS.ALL),
        // biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration
        type: 'item' as const,
      },
      {
        id: 'current-version',
        label: 'Current version',
        onSelect: () => setDiscussionsVersionFilter(ASSET_MODAL_DISCUSSION_VERSION_FILTERS.CURRENT),
        // biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration
        type: 'item' as const,
      },
    ],
    [setDiscussionsVersionFilter],
  );

  return (
    <DropdownMenu
      trigger={
        <Button
          appearance="ghost"
          className="px-1.5"
          color="gray"
          data-testid="COMMENTS_VERSIONS_DROPDOWN"
          size="small"
          suffix={<ChevronDownIcon size="xs" />}
        >
          {discussionsVersionFilter === ASSET_MODAL_DISCUSSION_VERSION_FILTERS.ALL
            ? 'All versions'
            : `Version ${versionNumber}`}
        </Button>
      }
    >
      {renderDropdownItems({ options })}
    </DropdownMenu>
  );
};
